import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import ChampQuiz from "./ChampQuiz";
import ItemQuiz from "./ItemQuiz";
import Nav from "./Nav";

export default function App() {
  return (
    <Router>
      <div className="App">
        <Nav />

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/items">
            <ItemQuiz />
          </Route>
          <Route path="/">
            <ChampQuiz />
          </Route>
        </Switch>

        <div style={{ padding: "5px 0" }}>
          Made by{" "}
          <a href="http://twitter.com/troyrcosentino">@troyrcosentino</a>
        </div>
      </div>
    </Router>
  );
}
